// extracted by mini-css-extract-plugin
export default {"form":"PromotionModal_form__j7ciT","field":"PromotionModal_field__AQ3f1"};